module.exports = __webpack_public_path__ + "img/img_product_06@2x.9fc6a3df.png";